import api from '@/api/api.js'

export default {
    getListeFournisseur() {
        const promise = api.comptabilite().get('/fournisseurs')
        return promise.then((response) => response.data)
    },

    getListeDette(data) {
        const promise = api.comptabilite().post('/dettes', data)
        return promise.then((response) => response.data)
    },

    saveDette(data) {
        const promise = api.comptabilite().post('/dettes/store', data)
        return promise.then((response) => response.data)
    },

    removeDette(data) {
        const promise = api.comptabilite().post('/dettes/delete', data)
        return promise.then((response) => response.data)
    },

    saveReglementDette(data) {
        const promise = api.comptabilite().post('/dettes/store/reglement', data)
        return promise.then((response) => response.data)
    },

    getListeHistoriqueDette(data) {
        const promise = api.comptabilite().post('/dettes/historique-paiement', data)
        return promise.then((response) => response.data)
    },

    checkIfDetteIsPaid(dette_id) {
        const promise = api.comptabilite().get('/dettes/'+dette_id+'/check-if-paid')
        return promise.then((response) => response.data)
    },

    getDetteMontantRestant(dette_id) {
        const promise = api.comptabilite().get('/dettes/'+dette_id+'/montant-restant')
        return promise.then((response) => response.data)
    },

    getListeRecapDepenseBudgetaire(data) {
        const promise = api.comptabilite().post('/ligne-budgetaire/recap', data)
        return promise.then((response) => response.data)
    },

    getListeRecapDepenseBudgetaireDetail(data) {
        const promise = api.comptabilite().post('/caisse-operations/depense-budgetaire', data)
        return promise.then((response) => response.data)
    },

    getListeApportSocial(data) {
        const promise = api.comptabilite().post('/ligne-budgetaire/apport-social', data)
        return promise.then((response) => response.data)
    },
}